import { useMutation } from '@tanstack/react-query';
import { deleteBankAddress } from '../requests';

type Options = {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
};

type DeleteBankAddressVariables = {
  templateId: string;
};

export function useDeleteBankAddress({ onSuccess, onError }: Options) {
  const mutation = useMutation<void, Error, DeleteBankAddressVariables>({
    mutationFn: ({ templateId }) => deleteBankAddress(templateId),
    onSuccess,
    onError,
  });

  return {
    mutate: mutation.mutate,
    mutateAsync: mutation.mutateAsync,
    data: mutation.data,
    isPending: mutation.isPending,
    error: mutation.error,
  };
}
